// @mui material components
import Icon from "@mui/material/Icon";

// Pages
import Home from "layouts/pages/home";
import Contact from "layouts/pages/contact";
import Gallery from "layouts/pages/gallery";
import About from "layouts/pages/about";
import Booking from "layouts/pages/booking";
import CarRentals from "layouts/pages/car-rentals";

const routes = [
  {
    name: "home",
    icon: <Icon>home</Icon>,
    route: "/",
    component: <Home />,
  },
  {
    name: "contact us",
    icon: <Icon>contact_mail</Icon>,
    route: "/contact",
    component: <Contact />,
  },
  {
    name: "gallery",
    icon: <Icon>photo_library</Icon>,
    route: "/gallery",
    component: <Gallery />,
  },
  {
    name: "about",
    icon: <Icon>info</Icon>,
    route: "/about",
    component: <About />,
  },
  {
    name: "car rentals",
    icon: <Icon>directions_car</Icon>,
    route: "/car-rentals",
    component: <CarRentals />,
  },
  {
    name: "book now",
    icon: <Icon>calendar_month</Icon>,
    route: "/booking",
    component: <Booking />,
  },
];

export default routes;
